/**
 * @description - function that returns the overall div selector, depending on which tab (regular purchase or subscription) is active
 * @returns {string} the jquery selector of the overall div
 */
function resolveActiveTabSelector() {
    if ($('.tab-subscription-pdp.active').length > 0) {
        return '.subscription-pdp';
    } else if ($('.recipeCtn.show').length > 0 && $('.recipeBody[data-subscription-id]"').length > 0) {
        return '.recipeBody[data-subscription-id="' + $('.recipeCtn.show .recipeBody').data('subscription-id') + '"]';
    } else if ($('#modalGlobalRyk.show').length > 0 && $('#modalGlobalRyk .recipeBody[data-lineitem-uuid]').length > 0) {
        return '.recipeBody[data-lineitem-uuid="' + $('#modalGlobalRyk.show .recipeBody').data('lineitem-uuid') + '"]';
    }

    return '.buy-one-pdp';
}

/**
 * @description - function that returns a boolean indicating if the Subscription tab is active
 * @returns {boolean} the resulting boolean
 */
function isTabSuscriptionActive() {
    return $('.tab-subscription-pdp').hasClass('active');
}

/**
 * Display or hide the error message based on eye
 * selection
 *
 * @returns {boolean} validation status
 */
function validateSubscriptionEyeSelection() {
    $('.step1 .step1-options-error-message').addClass('d-none');
    $('.step1 .step1-options .label').removeClass('invalid');

    if (isTabSuscriptionActive() && !$('input:radio[name=step1]').is(':checked')) {
        $('.step1 .step1-options-error-message').removeClass('d-none');
        $('.step1 .step1-options .label').addClass('invalid');
        window.scroll(0, $('#nav-subscription-tab').offset().top);

        return false;
    }

    return true;
}

/**
 * Validates when the user chooses the one eye option
 *
 * @returns {boolean} If the selection is valid
 */
function validateOnEyeEyeSelection() {
    if (!isTabSuscriptionActive()) {
        return true;
    }

    if (!$('input:radio[name=step1]').is(':checked')) {
        return true;
    }

    if ($('.step1dot1').hasClass('d-none')) {
        return true;
    }

    if (!$("input:radio[name='step1.1']").is(':checked')) {
        $('.step1dot1 .step1-options-error-message').removeClass('d-none');
        $('.step1dot1 .step1-options .label').addClass('invalid');
        window.scroll(0, $('#nav-subscription-tab').offset().top);

        return false;
    }

    return true;
}

module.exports = {
    resolveActiveTabSelector: resolveActiveTabSelector,
    isTabSuscriptionActive: isTabSuscriptionActive,
    validateSubscriptionEyeSelection: validateSubscriptionEyeSelection,
    validateOnEyeEyeSelection: validateOnEyeEyeSelection
};
